import GenerateReport from "./views/GenerateReport.vue";
import AllReports from "./views/AllReports.vue";
export default [
  {
    path: "generate",
    component: GenerateReport,
  },
  {
    path: "report",
    component: AllReports,
    name: "view-ess-attendance-reports",
  },
];
